//const REACT_API_BASE_URL='https://ev.smartiotcloud.io'
const REACT_API_BASE_URL='https://iot.smartupden.com/api'
export default REACT_API_BASE_URL;
